import * as yup from 'common/yup';
import {enumType} from '../common/enumType';

export const SymmetricAlgorithm = enumType({
   /**
    * A constant representing the AES-128 algorithm.
    */
   AES_128: 'AES-128',
   /**
    * A constant representing the AES-192 algorithm.
    */
   AES_192: 'AES-192',
   /**
    * A constant representing the AES-256 algorithm.
    */
   AES_256: 'AES-256',
   /**
    * A constant representing the BLOWFISH algorithm.
    */
   BLOWFISH: 'BLOWFISH',
   /**
    * A constant representing the CAST5 algorithm.
    */
   CAST5: 'CAST5',
   /**
    * A constant representing the DES algorithm.
    */
   DES: 'DES',
   /**
    * A constant representing the IDEA algorithm.
    */
   IDEA: 'IDEA',
   /**
    * A constant representing the SAFER algorithm.
    */
   SAFER: 'SAFER',
   /**
    * A constant representing the Triple DES algorithm.
    */
   TRIPLE_DES: 'TRIPLE-DES',
   /**
    * A constant representing the TWOFISH algorithm.
    */
   TWOFISH: 'TWOFISH',
});

export const SymmetricAlgorithmSchema = yup.string().oneOf(SymmetricAlgorithm.keys);
